import React from "react";
import Images from "../Images";
import tw from "tailwind-styled-components";
import LoginRight from "./LoginRight";

function Login() {
  return (
    <div className="flex min-h-screen flex-col lg:flex-row">
      <div className="lg:w-1/2 bg-[#26A69A] text-white hidden lg:grid place-items-center min-h-screen lg:p-10">
        <div className="max-w-xl lg:max-w-xl w-full">
          {/* <div className="flex space-x-6 mb-8 mt-4">
            <Logo src={Images.Login_Logo} alt="logo"
              className="w-24 sm:w-12 md:w-16 lg:w-24 h-auto" />
          </div> */}

          <h1 className="lg:text-5xl font-bold mb-3">Your partner to</h1>
          <h1 className="lg:text-5xl font-bold mb-8"> Close More Retail Deals
          </h1>

          <p className="text-sm text-gray-300 mr-9 mb-12">
            Manage inventory, track broker deals, follow up with clients, and monitor
            commissions - all in one powerful retail workspace built for brokers.
          </p>

          <div className="
            bg-white/10
            backdrop-blur-sm
            border border-white/20
            p-5
            rounded-xl
            shadow-lg
            w-full lg:w-4/5 
          ">
            <h3 className="font-semibold mb-2 text-white">
              Deals tracking finally feels effortless
            </h3>

            <p className="text-sm mb-4 text-blue-100">
              Kipinn Retail helped us organise inventory, follow-ups, and commissions in
              one place. Our team closes deals faster without losing track.
            </p>

            <div className="flex items-center justify-between">
              <div className="flex items-center">
                <img
                  src="https://placehold.co/40"
                  alt="User"
                  className="w-10 h-10 rounded-full mr-3"
                />
                <p className="font-semibold text-white">
                  Retail Broker • Gurgaon
                </p>
              </div>

              <div className="text-yellow-300">★★★★★</div>
            </div>
          </div>
        </div>
      </div>

      {/* Right Section */}
      <div className="lg:w-1/2 flex flex-col justify-center">
        <LoginRight />
      </div>
    </div>
  );
}

const Logo = tw.img`w-20 h-20 object-contain mb-10`;

export default Login;
